<template>

</template>

<script>

    import {useStore} from "vuex";
    import {ref, onMounted} from "vue";
    import TableComponent from "../../components/TableComponent";
    import repository from "../../../api-services/repository";
    import LaravelVuePagination from 'laravel-vue-pagination';

    export default {
        name: 'setting-entity-page',
        components: {TableComponent, 'Pagination': LaravelVuePagination},
        setup() {
            const store = useStore();
            let entities = ref([]);
            let originalEntities = ref([]);
            const thead = ref(['entity name']);
            const keys = ref(['name']);
            const laravelData = ref({});
            const search = ref(false);
            const sort = ref('asc');

            onMounted(async () => {
                await store.dispatch('activeTap', 'settings-entities');
                await getEntities();
            });


            const searchHandler = (e) => {
                let serachedValue = e.target.value;
                let searchedData = originalEntities.value.filter((data) => data.name.includes(serachedValue));
                entities.value = searchedData;
            }
            const getEntities = async (page = 1) => {
                try {
                    let entitiesData = await repository.index('entities', search.value, sort.value, page);
                    laravelData.value = entitiesData.data.data;
                    entities.value = entitiesData.data.data.data;
                    originalEntities.value = entitiesData.data.data.data;
                    if (process.env.VUE_ENV === 'development')
                        console.log('entity data ', entitiesData.data.data.data)
                } catch (e) {
                    if (process.env.VUE_ENV === 'development')
                        console.log({e})
                }
            }
            const updateHandler = (event) => {
                entities.value = entities.value.filter((entity) => {
                    return entity.id !== event
                })
            };

            return {
                thead,
                keys,
                entities,
                laravelData,
                search,
                getEntities,
                updateHandler,
                searchHandler
            }
        }
    }
</script>
<style scoped>

</style>